export default {
  latestVersion: {},
  latestDesktopVersion: {},
  latestIOSVersion: {},
}
